import React from 'react';
import ViewSmall from '../../../../../../ui_components/MediaView/ViewSmall';
import ViewMedium from '../../../../../../ui_components/MediaView/ViewMedium';
import ViewLarge from '../../../../../../ui_components/MediaView/ViewLarge';
import CustomCategorySalePriceRowMedium from './CustomCategorySalePriceRowMedium';
import CustomCategorySalePriceRowProperties from './CustomCategorySalePriceRowProperties';


const CustomCategorySalePriceRow: React.FC<CustomCategorySalePriceRowProperties> = ({
                                                    customCategoryWeightRangeSalePrice,
                                                    salePrice,
                                                    onUpdate
                                                }) => {
    return (
        <>
            <ViewSmall>
                <CustomCategorySalePriceRowMedium onUpdate={onUpdate} customCategoryWeightRangeSalePrice={customCategoryWeightRangeSalePrice} salePrice={salePrice}/>
            </ViewSmall>
            <ViewMedium>
                <CustomCategorySalePriceRowMedium onUpdate={onUpdate} customCategoryWeightRangeSalePrice={customCategoryWeightRangeSalePrice} salePrice={salePrice}/>
            </ViewMedium>
            <ViewLarge>
                <CustomCategorySalePriceRowMedium onUpdate={onUpdate} customCategoryWeightRangeSalePrice={customCategoryWeightRangeSalePrice} salePrice={salePrice}/>
            </ViewLarge>
        </>
    )
}

export default CustomCategorySalePriceRow;
